import api from 'services/api';
import { curry } from 'lodash';
import Logger from 'components/common/helpers/devConsoleLog';
import { Dispatch } from 'redux';
import {
  CREATE_SUBSCRIPTION,
  GET_AVAILABLE_CARDS,
  GET_AVAILABLE_PLANS,
  SET_USER_DEFAULT_PAYMENT_METHOD,
  SET_REFFERALS_ERRORS,
  SET_USER_REFERRAL_INFO,
} from './actionTypes';

const createAction = curry(<P>(type: string, payload: P) => ({
  type,
  payload,
}));

export const getAvailablePlans = () => async (
  dispatch: Dispatch
): Promise<void> => {
  const { data } = await api.get('/payments/available-plans');

  return dispatch(createAction(GET_AVAILABLE_PLANS, data));
};

export const getAvailableCards = () => async (
  dispatch: Dispatch
): Promise<void> => {
  const { data } = await api.get('/payments/payment-methods');

  return dispatch(createAction(GET_AVAILABLE_CARDS, data));
};

export const createSubscription = (params: {
  planId: string;
  paymentMethodId: string;
}) => async (dispatch: Dispatch): Promise<void> => {
  const { data } = await api.post('/payments/subscriptions', params);

  return dispatch(createAction(CREATE_SUBSCRIPTION, data));
};

export const setDefaultPaymentMethod = (params: { id: string }) => async (
  dispatch: Dispatch
): Promise<void> => {
  const { data } = await api.put('/payments/payment-methods/default', params);

  return dispatch(createAction(SET_USER_DEFAULT_PAYMENT_METHOD, data));
};

export const userInvite = (params: {
  html: string;
  emails: string[];
}) => async (dispatch: Dispatch): Promise<void> => {
  dispatch(createAction(SET_REFFERALS_ERRORS, ''));
  try {
    await api.post('/user-referral/invite', params);
  } catch (error) {
    dispatch(createAction(SET_REFFERALS_ERRORS, error.response.data?.message));
  }
};

export const getReferralInfo = () => async (
  dispatch: Dispatch
): Promise<void> => {
  try {
    const { data } = await api.get('/user-referral/benefits-info');
    dispatch(createAction(SET_USER_REFERRAL_INFO, data));
  } catch (error) {
    Logger('getReferralInfo error:', error);
  }
};
